class Monitoring.Methods.TelcelAnalyticsAsyncJob extends Backbone.View

  start: (params) =>
    @job = new ResqueJobWithHandleableErrors
      url: '/monitoring/publications/telcel_analytics_export',
      data: params
      success: (results) =>
        @trigger('completed', results)
      error: =>
        @trigger('failed')
      handle_error: (results) =>
        @trigger('show_error', results.error)
      confirm_export: =>
        @trigger('confirm_export')
    @job.start()

  stop: ->
    @job.stop()
